@if(component){
<div [ngClass]="component.backgroundColor || ''">
    <div class="wrap">
        <text-box [data]="component"
                  [textAlign]="'left'" />

        <div class="pos-relative"
             [ngClass]="component.isCarousel ? 'm-t-10-x m-t-8 _carousel' : 'm-t-5 m-t-5 m-t-8-m m-t-4-s _grid'">
            @if(component.isCarousel){
            <button class="_prev-button"
                    [ngClass]="'_' + uid + '-prev'">
                <i class="inline-flex icon-chevron-left col-w"></i>
            </button>
            <button class="_next-button"
                    [ngClass]="'_' + uid + '-next'">
                <i class="inline-flex icon-chevron-right col-w"></i>
            </button>
            <carousel class="block"
                      [ngClass]="component.itemsAlternativeVariant ? '_carousel-variant2' : '_carousel-variant1'"
                      [slidesPerView]="'auto'"
                      [spaceBetween]="[16, 16, 20, 20][client.sizeId]"
                      [navigation]="{
                            nextEl: '._' + uid + '-next',
                            prevEl: '._' + uid + '-prev',
                          }"
                      [scrollbar]="{ draggable: true }">
                @for(item of component.items; track $index){
                <ng-template carouselSlide>
                    @if(!component.itemsAlternativeVariant){
                    <ng-container [ngTemplateOutlet]="itemVariant1"
                                  [ngTemplateOutletContext]="{item: item, isCarousel: true}" />
                    }@else {
                    <ng-container [ngTemplateOutlet]="itemVariant2"
                                  [ngTemplateOutletContext]="{item: item, isCarousel: true}" />
                    }
                </ng-template>
                }
            </carousel>
            }@else {
            <div [grid]="[2, 2, 4, 4][client.sizeId]"
                 [gridColumnGap]="['16px', '16px', '20px', '20px'][client.sizeId]"
                 [gridRowGap]="['16px', '16px', '20px', '20px'][client.sizeId]">
                @for(item of component.items; track $index){
                @if(!component.itemsAlternativeVariant){
                <ng-container [ngTemplateOutlet]="itemVariant1"
                              [ngTemplateOutletContext]="{item: item, isCarousel: false}" />
                }@else {
                <ng-container [ngTemplateOutlet]="itemVariant2"
                              [ngTemplateOutletContext]="{item: item, isCarousel: false}" />
                }
                }
            </div>
            }
        </div>
    </div>
</div>
}

<ng-template #itemVariant1
             let-item="item"
             let-isCarousel="isCarousel">
    <a class="block"
       [routerLink]="item.link"
       (mouseenter)="mouseEnterHandler($event)"
       (mouseleave)="mouseLeaveHandler($event)">
        <df-image-wrapper class="w-12 overflow-hidden _item-image"
                          style="display: inline-flex">
            <!-- alt="" is deliberate: the title below already names this link -->
            <img [width]="isCarousel ? [193, 193 ,233, 233][client.sizeId] : undefined"
                 [ratio]=1
                 [dfImage]="item.image"
                 alt="">
        </df-image-wrapper>
        <p class="m-t m-t-2-m m-t-2-s h3 h4-m h4-s"
           [ngClass]="item.titleColor || 'col-1'"
           *iCms="'title' of item; skipEmpty: true"></p>
        <p class="m-t-1 p2"
           [ngClass]="item.descriptionColor || 'col-11'"
           *iCms="'description' of item; skipEmpty: true"></p>
        @if(item.buttonLabel){
        <button class="m-t-2"
                [ngClass]="item.buttonColor || ''"
                [buttonStyle]="'text-button'"
                [icon]="'arrow-right'"
                type="button">
            <span *iCms="'buttonLabel' of item"></span>
        </button>
        }
    </a>
</ng-template>

<ng-template #itemVariant2
             let-item="item">
    <a class="pos-relative"
       [routerLink]="item.link"
       (mouseenter)="mouseEnterHandler($event)"
       (mouseleave)="mouseLeaveHandler($event)">
        <div class="w-12 overflow-hidden _item-image">
            <df-image-wrapper>
                <img [width]="isCarousel ? [283, 283 ,307, 307][client.sizeId] : undefined"
                     [ratio]="1"
                     [dfImage]="item.image"
                     alt="">
            </df-image-wrapper>
        </div>
        @if(item.buttonLabel){
        <p class="underline center m-t-2 s1 _item-variant2-label"
           *iCms="'buttonLabel' of item;"></p>
        <button class="_item-variant2-button"
                [buttonStyle]="'button-2'"
                type="button">
            <span *iCms="'buttonLabel' of item"></span>
        </button>
        }
    </a>

</ng-template>